import { CheckCircleIcon, PaperAirplaneIcon } from "@heroicons/react/outline";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  allowEditing: boolean;
  saveState: string;
  handleSave: () => void;
  sendState?: string;
  handleSend?: () => void;
}

function WorkflowEmailSave(props: Props) {
  const { saveState, sendState, allowEditing, handleSave, handleSend } = props;
  const { t } = useTranslation();

  // const isMac = navigator.platform.toLowerCase().indexOf("mac") >= 0;

  useLayoutEffect(() => {
    function metaEnterHandler(e: KeyboardEvent) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {

        if (handleSave && saveState === "HAS_CHANGES")
          handleSave();

        else if (handleSend && (saveState === "INITIAL" || saveState === "SAVED"))
          handleSend();
      }
    }

    window.addEventListener('keydown', metaEnterHandler);
    return () => {
      window.removeEventListener('keydown', metaEnterHandler);
    };

  }, [handleSave, handleSend, saveState]);

  return (
    <div className="flex items-center gap-2 relative group ml-auto mb-2">
      {(saveState === "INITIAL" && !handleSend) &&
        <button className=" btn btn-blue w-32" disabled>
          {t("Save")}
        </button>
      }
      {(saveState === "HAS_CHANGES" && !handleSend) &&
        <button className={`btn btn-blue w-32`} onClick={handleSave} disabled={!allowEditing}>
          {t("Save")}
        </button>
      }
      {(saveState === "HAS_CHANGES" && !!handleSend) &&
        <button className={`btn btn-gray w-32 whitespace-nowrap`} onClick={handleSave} disabled={!allowEditing}>
          {t("Save draft")}
        </button>
      }
      {(saveState === "SAVING" && sendState === "INITIAL") &&
        <button className=" btn btn-blue w-32" disabled>
          {t("Saving...")}
        </button>
      }
      {(saveState === "SAVED" && sendState === "INITIAL") &&
        <button className=" btn btn-green w-32" disabled>
          {t("Saved")} <CheckCircleIcon className="w-4 h-4 flex-shrink-0 text-green ml-2" />
        </button>
      }

      {!!handleSend &&
        <>
          {(sendState === "INITIAL") &&
            <button className=" btn btn-purple w-32" onClick={handleSend}>
              {t("Send")} <PaperAirplaneIcon className="w-4 h-4 ml-2 flex-shrink-0 rotate-90" />
            </button>
          }
          {(sendState === "SENDING") &&
            <button className=" btn btn-blue w-32" disabled>
              {t("Sending...")}
            </button>
          }
          {(sendState === "SENT") &&
            <button className=" btn btn-green w-32" disabled>
              {t("Sent")} <CheckCircleIcon className="w-4 h-4 flex-shrink-0 text-green ml-2" />
            </button>
          }
        </>}
      {/* <p className={`text-xs font-semibold font-gilroy text-gray-400 opacity-0 transition-opacity text-center ${!handleSend ? "group-hover:opacity-100" : ""}`}>
        {t("Shortcut:")} {isMac ? "⌘" : "Ctrl "} + Enter
      </p> */}
    </div>
  );
}

export default WorkflowEmailSave;
